export default {
  h1: {
    fontWeight: 500,
    fontSize: 45,
    lineHeight: "52px",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "30px !important",
      lineHeight: "40px",
    },
  },
  h2: {
    fontWeight: 400,
    fontSize: 40,
    lineHeight: "45px",
    fontFamily: "'Poppins', sans-serif",
    wordBreak: "break-word",
    "@media(max-width:767px)": {
      fontSize: "25px !important",
      lineHeight: "30px !important",
    },
  },
  h3: {
    fontWeight: 600,
    fontSize: 30,
    lineHeight: "40px",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },
  h4: {
    fontWeight: 400,
    fontSize: 28,
    lineHeight: "30px",
    color: "#2c384a",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "18px !important",
    },
  },

  h5: {
    fontWeight: 500,
    fontSize: 20,
    lineHeight: "30px",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "16px !important",
    },
  },
  h6: {
    fontWeight: 400,
    fontSize: 18,
    lineHeight: "24px",
    color: "#262626",
    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      lineHeight: "22px",
      fontSize: "14px !important",
    },
  },
  overline: {
    fontWeight: 500,
    fontFamily: "'Poppins', sans-serif",
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Poppins', sans-serif",
  },

  body2: {
    fontSize: 16,
    fontWeight: "400",
    lineHeight: "20px",

    fontFamily: "'Poppins', sans-serif",
    "@media(max-width:767px)": {
      fontSize: "12px",
      lineHeight: "18px",
    },
  },
  body1: {
    fontWeight: 400,
    lineHeight: "20px",
    fontSize: 14,
    fontFamily: "'Poppins', sans-serif",
    // wordBreak:"break-all"

    // fontFamily: "'Poppins, sans-serif'",
  },
};
